import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  overtimeList: [], 
  overtimeArr: [],
  overtimeArray: [],
  overtimeID: '',
  selectedOvertime: null,
  selectedLedger: null,
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.overtimeList = [];
    state.overtimeArr = [];
    state.overtimeArray = [];
    state.overtimeID = "";
    state.selectedOvertime = null;
    state.selectedLedger = null;
    state.isEditing = false;
  },
  SET_SELECTED_OVERTIME(state, Overtime) {
    state.selectedOvertime = Overtime;
    state.isEditing = true;
  },
  LIST_OVERTIMES(state, Overtimes) {
    state.overtimeList = Overtimes;
  },
  OVERTIME_ARRAY(state, Overtimes){
    state.overtimeArray = Overtimes;
  },
  SET_SELECTED_LEDGER(state, ledger) {
    state.selectedLedger = ledger;
  },
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){
    }
  },
  RESET_SEARCH_FILTERS(state){

  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createOvertimePolicy({ commit,state }, formData) {
    return axios.post('api/v1/create-overtime-policy/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })
  },

  fetchOvertimePolicies({ commit,state }, formData) {
    state.overtimeArr = [];
    axios.post(`api/v1/get-overtime-policies/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.overtimeArr.push((response.data[i].name));
      }
      commit('LIST_OVERTIMES', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchOvertimePolicy({ commit,state }, formData) {
    axios.post(`api/v1/get-overtime-policies/`,formData)
    .then((response)=>{
      state.selectedOvertime = response.data;
      const selectedLedger = response.data.posting_account.ledger_code + " - " + response.data.posting_account.ledger_name;
      commit('SET_SELECTED_OVERTIME',response.data);
      commit('SET_SELECTED_LEDGER', selectedLedger);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedOvertime({ commit, state }, option){
    const selectedOvertime = state.overtimeList.find(overtime => (overtime.name) === option);
    if (selectedOvertime) {
        state.overtimeID = selectedOvertime.overtime_policy_id;
        selectedOvertime.employee_overtime_id = null;
        state.overtimeArray = [...state.overtimeArray, selectedOvertime];
    }
    commit('OVERTIME_ARRAY', state.overtimeArray);
      
  },

  async updateOvertimePolicy({ commit,state }, formData) {
    return axios.put(`api/v1/update-overtime-policy/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteOvertimePolicy({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Overtime?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Overtime!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-overtime-policy/`,formData)
        .then((response)=>{
          if(response.status == 200){
              Swal.fire("Poof! Overtime removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Overtime",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Overtime has not been deleted!`);
      }
    })
  },
  removeOvertime({commit, state}, index){
    state.overtimeArray.splice(index, 1); 
    commit('OVERTIME_ARRAY', state.overtimeArray);
  },
};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  